module.exports = __webpack_public_path__ + "static/media/ic-powerful.bf0a96ff.svg";